export const stats = [
  { value: '+580', label: 'cuidadoras ya usando el kit' },
  { value: '3', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos incluidos' },
  { value: '4.9/5', label: 'calificación' },
];

export const testimonials = [
  {
    initials: 'SM',
    name: 'Sofía M.',
    place: 'Buenos Aires',
    quote:
      'Por primera vez pudimos hablar de un tema sin que terminara en pelea. Sentí que me escuchaba.',
  },
  {
    initials: 'PL',
    name: 'Patricia L.',
    place: 'Córdoba',
    quote:
      'Tenía las herramientas para conversar sin sonar como si le estuviera imponiendo nada.',
  },
  {
    initials: 'LS',
    name: 'Lorena S.',
    place: 'Rosario',
    quote:
      'Los acuerdos que hicimos hace dos semanas siguen funcionando. No se olvida todo como antes.',
  },
  {
    initials: 'MR',
    name: 'Marisa R.',
    place: 'Mendoza',
    quote:
      'Sé cómo prepararme antes de hablar. Llego más tranquila y eso cambia todo el tono de la conversación.',
  },
];

export const extendedTestimonials = [
  {
    name: 'Sofía M.',
    place: 'Buenos Aires',
    quote:
      '“Pudimos hablar de algo importante sin que terminara en pelea. Por primera vez sentí que realmente me escuchaba.”',
  },
  {
    name: 'Patricia L.',
    place: 'Córdoba',
    quote:
      '“Tenía las herramientas para plantear una propuesta sin sonar como si le estuviera imponiendo nada.”',
  },
  {
    name: 'Lorena S.',
    place: 'Rosario',
    quote:
      '“Los acuerdos que hicimos hace dos semanas siguen funcionando. No se olvida todo como antes.”',
  },
  {
    name: 'Marisa R.',
    place: 'Mendoza',
    quote:
      '“Sé cómo prepararme antes de hablar. Llego más tranquila y eso cambia todo el tono de la conversación.”',
  },
];

export const purchases = [
  { name: 'Sofía M.', place: 'Buenos Aires' },
  { name: 'Patricia L.', place: 'Córdoba' },
  { name: 'Lorena S.', place: 'Rosario' },
  { name: 'Marisa R.', place: 'Mendoza' },
];
